export default __webpack_public_path__ + "static/media/apple-app-store-badge.97dd9b81.png";